
  import { mapGetters, mapState } from 'vuex'
  import 'swiper/swiper-bundle.css'
  import cms from '~/mixins/common/cms'
  import playGames from '~/mixins/common/play-games'

  export default {
    mixins: [cms, playGames],
    data() {
      return {
        featuredContentItemWidth: 280
      }
    },
    computed: {
      ...mapState({
        isLoading: state => state.settings.loading
      }),
      ...mapGetters({
        footerImageDesktopContent: 'cms/footerImageDesktop',
        certificateImage: 'cms/certificateImage'
      }),
      footerImageDesktop() {
        return this.footerImageDesktopContent(this.$config.THEME)
      }
    },
    methods: {
      getContentWidth() {
        const client = process.client
        if (client) {
          const val = this.$refs?.refFeature?.clientWidth
          if (val) {
            this.featuredContentItemWidth = Math.ceil(val / 4) - 12
          }
        } else {
          setTimeout(() => {
            this.getContentWidth()
          }, 1000)
        }
      }
    }
  }
